export default __webpack_public_path__ + "static/ruler-18a863ed9ac92c6d1069d86ebad0fa47.svg";